import apiClient from "../common/apiClient";

export default class MedicalCenterController {
  async Create(data, token) {
    try {
      return await apiClient.post("/medical-center", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Update(data, token) {
    try {
      return await apiClient.put("/medical-center", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Delete(id, token) {
    try {
      return await apiClient.delete("/medical-center/" + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async GetAllMedicalCenter(token) {
    try {
      return await apiClient.get("/medical-centers", {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
}
